<template>
  <div class="main uploadFileMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback" />
      <span>返回</span>
      <img class="process" src="../assets/process2.jpg" />
    </div>
    <!-- 下部分 -->
    <div class="textMain">
      <p>
        <a :href="downloadUrl + downloadPath" target="_blank">点击下载申报书与承诺书</a>，
        文件下载后，将申报书（一式两份）、承诺书（一式两份）、连同主申报单位、
        </p>
      <br />
      <p>联合申报单位、业主单位相关资质文件（营业执照、资质证书等）全部盖章并转为pdf文件，</p>
      <br />
      <p>点击“选择文件”上传，完成后点击“暂存,下一步”</p>
    </div>
    <div style="display: flex;justify-content: center;">
      <FileUploader
        class="fileUploaderClass"
        :fileList="fileList"
        :handleChange="handleChange"
        :delFromServer="delFromServer"
        :backFileList="backFileList"
      />
      <div>
        <el-button type="primary" size="small" @click="next" :loading="loading">暂存，下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import FileUploader from '../components/FileUploader'
import config from '../config'

const { downloadUrl } = config

export default {
  components: {
    FileUploader
  },
  data () {
    return {
      downloadUrl,
      loading: false,
      fileList: [],
      backFileList: [],
      downloadPath: ''
    }
  },
  mounted () {
    this.asyncQueryPdf()
    let params = {
      id: this.$route.query.id
    }
    API.downloadDocument(params).then(resp => {
      if (resp.resultCode === '0000') {
        this.downloadPath = resp.data
      }
    })
  },
  methods: {
    // 查询PDF文件
    asyncQueryPdf () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.queryPdf(params).then(resp => {
        if (resp.resultCode === '0000') {
          let arr = []
          this.backFileList =
            resp.data === null ? arr : arr.concat(resp.data.address)
        }
      })
    },
    // 从服务器删除文件
    delFromServer () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.deletePdf(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('删除成功！')
          this.asyncQueryPdf()
        }
      })
    },
    handleChange (file) {
      let fileType = file.name.substring(file.name.lastIndexOf('.'))
      if (fileType !== '.pdf') {
        this.$message.error('请上传.pdf类型的文件！')
        return
      }
      if (this.fileList.length + this.backFileList.length > 0) {
        this.$message.error('只能上传一个文件')
        return
      }
      this.fileList.push(file)
    },
    goback () {
      this.$router.go(-1)
    },
    next () {
      if (!this.fileList.length && !this.backFileList.length) {
        this.$message.error('请选择一个文件上传')
        return
      } else if (this.fileList.length + this.backFileList.length > 1) {
        this.$message.error('只能上传一个文件')
        return
      }
      this.loading = true
      let _pdffile = this.fileList[0] || this.backFileList[0]
      if (typeof _pdffile !== 'string') {
        let params = {
          project_declare_id: this.$route.query.id,
          pdffile: _pdffile
        }
        API.uploadPDF(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.loading = false
            this.$router.push('/send?id=' + this.$route.query.id)
          }
        })
      } else {
        this.loading = false
        this.$router.push('/send?id=' + this.$route.query.id)
      }
    }
  }
}
</script>

<style lang="scss">
.uploadFileMain {
  .fileUploaderClass {
    width: 250px;
    margin-right: 10px;
  }
  .textMain {
    color: #535050;
    text-align: center;
    margin: 80px 0;
    font-size: 20px;
  }
}
</style>
